var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "nti-product-info-tablist" }, [
    _c(
      "nav",
      { staticClass: "nti-product-info-tablist__tab-container tabs-filter" },
      [
        _vm._l(_vm.tablistData, function (data) {
          return [
            _c(
              "button",
              {
                key: data.id,
                staticClass:
                  "nti-product-info-tablist__tablink__wrapper nti-button nti-button--no-styling",
                attrs: { "aria-controls": "description", role: "tab" },
                on: {
                  click: function ($event) {
                    return _vm.activateTab(data.id)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "nav-link nav-link--webshop nti-product-info-tablist__tablink",
                    class: { active: _vm.selectedTab === data.id },
                  },
                  [_vm._v(_vm._s(data.tabHeader))]
                ),
              ]
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "nti-product-info-tablist__tabcontent",
        attrs: { id: "description", role: "tabpanel" },
      },
      [
        _vm._l(_vm.tabContentData, function (data, indexContent) {
          return [
            _c("p", {
              key: "A" + indexContent,
              staticClass: "nti-product-info-tablist__tabcontent__text",
              domProps: { innerHTML: _vm._s(data.text) },
            }),
          ]
        }),
        _vm._v(" "),
        _vm._l(_vm.tabLinkData, function (link, indexLink) {
          return [
            _c("a", { key: "B" + indexLink, attrs: { href: link.url } }, [
              _vm._v(_vm._s(link.text)),
            ]),
          ]
        }),
        _vm._v(" "),
        _vm.tabVideoData
          ? [
              _c(
                "div",
                { staticClass: "block-embed nti-product-info-tablist__video" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "video media parallax",
                      staticStyle: {
                        transform:
                          "translate3d(0px, 55px, 0px) translate3d(0px, 15px, 0px)",
                      },
                      attrs: {
                        "data-rellax-speed": "-0.25",
                        "data-rellax-percentage": "-0.25",
                      },
                    },
                    [
                      _c("iframe", {
                        attrs: {
                          src: _vm.tabVideoData,
                          frameborder: "0",
                          allowfullscreen: "",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "background-box parallax",
                    staticStyle: {
                      transform:
                        "translate3d(0px, -148px, 0px) translate3d(0px, 0px, 0px)",
                    },
                    attrs: {
                      "data-rellax-speed": "1",
                      "data-rellax-percentage": "0.5",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.tabNativeVideoData
          ? [
              _c(
                "div",
                { staticClass: "block-embed nti-product-info-tablist__video" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "video media parallax",
                      staticStyle: {
                        transform:
                          "translate3d(0px, 55px, 0px) translate3d(0px, 15px, 0px)",
                      },
                      attrs: {
                        "data-rellax-speed": "-0.25",
                        "data-rellax-percentage": "-0.25",
                      },
                    },
                    [
                      _c(
                        "video",
                        {
                          attrs: {
                            id: "native-video-player",
                            preload: "metadata",
                            autoplay: _vm.tabNativeVideoData.autoplayVideo,
                            poster: _vm.tabNativeVideoData.posterLink,
                          },
                          on: {
                            play: _vm.tabNativeVideoData.onVideoPlay,
                            pause: _vm.tabNativeVideoData.onVideoPause,
                            click: _vm.tabNativeVideoData.onVideoClick,
                          },
                        },
                        [
                          _c("source", {
                            attrs: {
                              src: _vm.tabNativeVideoData.videoLink,
                              type: "video/mp4",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "background-box parallax",
                    staticStyle: {
                      transform:
                        "translate3d(0px, -148px, 0px) translate3d(0px, 0px, 0px)",
                    },
                    attrs: {
                      "data-rellax-speed": "1",
                      "data-rellax-percentage": "0.5",
                    },
                  }),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }